import { render, staticRenderFns } from "./Decimal.vue?vue&type=template&id=535844c9"
import script from "./Decimal.vue?vue&type=script&lang=js"
export * from "./Decimal.vue?vue&type=script&lang=js"
import style0 from "./Decimal.vue?vue&type=style&index=0&id=535844c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports